import { render, staticRenderFns } from "./PainelApresentacao.vue?vue&type=template&id=ca2e33c0"
import script from "./PainelApresentacao.vue?vue&type=script&lang=js"
export * from "./PainelApresentacao.vue?vue&type=script&lang=js"
import style0 from "./PainelApresentacao.vue?vue&type=style&index=0&id=ca2e33c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports